<template>
<div class="chapter">
<div class="inner_page">
<section class="titlepage" epub:type="titlepage">
<div class="title_page_image"><img alt="The Dark Palace by R. N. Morris" src="images/scale~1920x1200~thedarkpal-1586346309-55.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter0.vue?0b86aaf8